import { type FC, useMemo } from 'react';

import { RenderingProvider, useCms } from '@eneco/cms';
import type { HeroRendering } from '@sitecore/types/manual/Hero.types';

import HeroRebrandedInner from './HeroRebrandedInner';

/**
 * Bridge for `HeroRebranded`. Identical wiring to `Hero` — see comments
 * there. Converts legacy JSS-shaped props to a `CmsRendering` and pushes it
 * into the `@eneco/cms` context for the inner body.
 */
const HeroRebranded: FC<HeroRendering> = ({ fields, params, placeholders }) => {
  const { adapter } = useCms();
  const rendering = useMemo(
    () =>
      adapter.toRendering({
        componentName: 'HeroRebranded',
        fields,
        params,
        placeholders,
      }),
    [adapter, fields, params, placeholders],
  );

  const hasLeftPlaceholder = !!placeholders?.['jss-hero-left']?.length;
  const hasRightPlaceholder = !!placeholders?.['jss-hero-right']?.length;
  const hasBottomPlaceholder = !!placeholders?.['jss-hero-bottom']?.length;

  return (
    <RenderingProvider rendering={rendering}>
      <HeroRebrandedInner
        hasLeftPlaceholder={hasLeftPlaceholder}
        hasRightPlaceholder={hasRightPlaceholder}
        hasBottomPlaceholder={hasBottomPlaceholder}
      />
    </RenderingProvider>
  );
};

export { HeroRebranded };
export default HeroRebranded;
